<template>
  <div class="action-buttons-section">
    <!-- Main Action Buttons -->
    <div v-if="listCount >= 0" class="main-actions">
      <div class="button-group">
        <el-button type="primary" :loading="actionInProgress" :disabled="!enableApproveReject || actionInProgress || hasAuthUserActioned" @click="$emit('approve', 'Approve')">
          Approve
        </el-button>
        <el-button
          type="danger"
          :loading="actionInProgress"
          :disabled="!enableApproveReject || actionInProgress || hasAuthUserActioned"
          v-if="currentApmdLvl > 1"
          @click="$emit('reject', 'Reject')"
        >
          Reject
        </el-button>
        <el-button
          type="warning"
          :loading="actionInProgress"
          :disabled="!['Draft', 'Pending'].includes(enrolStatus) || actionInProgress || hasAuthUserActioned"
          @click="$emit('delete')"
        >
          Delete
        </el-button>
      </div>
      <el-button class="save-button" type="secondary" @click="$emit('save')"> Save </el-button>
    </div>

    <!-- Divider -->
    <hr class="divider" />

    <!-- Student Actions -->
    <div class="student-actions">
      <a v-if="studentId" :href="`/student?id=${studentId}`" target="_blank" class="el-button el-button--secondary"> View Student </a>
      <el-button type="secondary" @click="$emit('create-student')"> {{ studentId ? 'Update' : 'Create' }} Student </el-button>
      <el-button v-if="studentId" type="secondary" @click="$emit('delete-student')"> Delete Student </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActionButtons',
  props: {
    listCount: {
      type: Number,
      default: 0,
    },
    enableApproveReject: {
      type: Boolean,
      default: false,
    },
    enrolStatus: {
      type: String,
      default: '',
    },
    currentApmdLvl: {
      type: Number,
      default: 0,
    },
    studentId: {
      type: String,
      default: '',
    },
    actionInProgress: {
      type: Boolean,
      default: false,
    },
    hasAuthUserActioned: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.action-buttons-section {
  margin: 30px 0;
}

.main-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.button-group {
  display: flex;
  gap: 10px;
}

.save-button {
  margin-left: auto;
}

.divider {
  border: none;
  border-top: 1px solid #e9ecef;
  margin: 20px 0;
}

.student-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.student-actions .el-button {
  margin: 0;
}

@media (max-width: 768px) {
  .main-actions {
    flex-direction: column;
    gap: 15px;
  }

  .button-group {
    width: 100%;
    justify-content: center;
  }

  .save-button {
    margin-left: 0;
    width: 100%;
  }

  .student-actions {
    justify-content: center;
  }
}
</style>
